<template>
	<div class="l-edit-dialog-box" style="height: 280px" v-loading="loading">
		<el-form :model="form_data" label-width="80px" ref="form" :rules="rules" label-position="left">
			<el-form-item :label="state == 2 ? '审批描述' : '拒绝原因'" prop="review_desc">
				<el-input :rows="10" type="textarea" :placeholder="state == 2 ? '请输入审批描述(选填)' : '请输入拒绝原因(选填)'" v-model="form_data.review_desc"> </el-input>
			</el-form-item>
		</el-form>

		<div class="l-dialog-footer">
			<el-button @click="cancel">取 消</el-button>
			<el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: "l-approval-review-remark",
	props: {
		id: {
			type: [Number, String],
			default: null,
		},
		state: {
			type: [Number, String],
			default: null,
		},
		visible: {
			type: Boolean,
		},
	},
	computed: {
		hasId() {
			return this.$props.id !== null;
		},
	},
	data() {
		return {
			loading: false,

			//表单数据
			submitting: false,

			form_data: {
				id: "",
				state: "",
				review_desc: "",
			},

			rules: {},
		};
	},

	watch: {
		visible: {
			immediate: true,
			handler(val) {
				console.log(val);
			},
		},
	},

	methods: {
		//点击取消通知父组件关闭对话框
		cancel() {
			this.$emit("update:visible", false);
		},

		//提交数据
		handleSubmit() {
			if (this.loading) return;
			this.$refs.form.validate((valid) => {
				if (valid) {
					this.submitting = true;
					//添加
					const params = {
						id: this.$props.id,
						state: this.$props.state,
						review_desc: this.form_data.review_desc,
					};
					this.$_invoke("approval_review", params)
						.then(() => {
							this.$_msg.success("提交成功");
							this.$emit("on-success");
						})
						.finally(() => {
							this.submitting = false;
						});
				}
			});
		},
	},
};
</script>
